module.exports = __webpack_public_path__ + "static/media/vn.3e303f7f.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/vn.svg
// module id = 798
// module chunks = 0